module.exports = __webpack_public_path__ + "img/linked-in-color.ae1e84b5.svg";